import Modal from './modal';
import {Cookies} from '../utilities/cookies';

const settings = {
    cookieName: 'hcp-confirmation',
    cookieExpirationDays: 100,

    activePageRegex: [
        /^\/resensation-surgeon-submission-form/,
        /^\/physician-toolkit-login/,
    ],

    selectors: {
        template: '.hcp-modal',
        yesButton: '.modal__yes-button',
        noButton: '.modal__no-button',
    },
};

let template = null;

export default class HcpModal extends Modal {
    constructor() {
        // Stop if we didn't locate our template
        if (!template) {
            throw new Error();
        }

        // Call base constructor
        super(template, false);

        // Setup buttons
        let button = this.container
            .querySelector(settings.selectors.yesButton);
        if (button) {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                // Create our cookie
                Cookies.create(
                    settings.cookieName,
                    'true',
                    settings.cookieExpirationDays,
                );

                // Close the modal
                this.close();
            });
        }

        button = this.container
            .querySelector(settings.selectors.noButton);
        if (button) {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                // Redirect to the site homepage
                window.location.href = '/';
            });
        }
    }

    static init() {
        // Locate our template element and remove it from the DOM
        template = document.querySelector(settings.selectors.template);
        if (!template) {
            return;
        }

        template.remove();
        template = template.outerHTML;

        // Load our cookie
        const storedHcpConfirmation = Cookies.read(settings.cookieName);
        if (storedHcpConfirmation === 'true') {
            // Cookie is already present - stop here
            return;
        }

        // Cookie isn't present - check if this is one of the pages
        // on which the modal should appear
        let modalShouldAppear = false;
        for (const regex of settings.activePageRegex) {
            if (regex.test(window.location.pathname)) {
                modalShouldAppear = true;
                break;
            }
        }

        if (!modalShouldAppear) {
            return;
        }

        // This page matched one of our regexes - show the modal
        const modal = new HcpModal();
        modal.show();
    }
}
